export default "__VITE_ASSET__BPu8OM2k__"